// extracted by mini-css-extract-plugin
export default {"newsContainer":"SnapshotNewsList_newsContainer__bEUTs","header":"SnapshotNewsList_header__lkIhA","symbol":"SnapshotNewsList_symbol__Tm-T6"};